// Create VueI18n instance with options
import Vue from 'vue';
import VueI18n from 'vue-i18n';
//import { store } from "../store/store";
import messages from "../lang";
import _ from 'lodash';
Vue.use(VueI18n);
let userLanguage = $cookies.get('userLanguage');
let navLanguage = navigator.language.split('-')[0];
_.isNull(userLanguage)? userLanguage = navLanguage :'';

const i18n = new VueI18n({
    locale: navigator.language != userLanguage ? userLanguage : navLanguage,// store.getters.selectedLocale.locale, // set locale
    fallbackLocale: navigator.language != userLanguage ? userLanguage : navLanguage, // set fallback locale
    messages, // set locale messages
});

export default i18n;